<template>
  <div class="no-service">
    <y-panel-msg title="提交成功" content="请等待客服联系您" :ico="require('@/assets/login-success.png')"></y-panel-msg>
    <div class="bottom">
      <div class="con">
        <a class="service-call" href="javascript:void(0)" @click="goto('KF_SERVICE')">
          <span><img src="@/assets/service-call.png" alt="service call" /></span>
          <span>客服</span>
        </a>
        <y-button class="btn" @click="gotoCard()">查看卡片</y-button>
      </div>
    </div>
  </div>
</template>

<script>
// import { getAgreementUrl } from '../../scripts/care_agreement';
export default {
  name: "ApplyServiceSuccess",
 
  created() {
    this.id = this.$route.params.id;
    window.temp = this
  },
  methods: {
    gotoCard(){
        this.$router.push("/care/" + this.id);
    }
  }
};
</script>
<style lang="less" scoped>
.no-service {
  height: 100vh;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  background: #efefef;
  .bottom{
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    .con{
      padding: 7px 23px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .service-call {
        display: flex;
        width: 54px;
        height: 54px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #4F4F4F;
        padding: 0 10px;
        img {
          width: 17px;
          height: 18px;
        }
      }
      .btn{
        flex: 1 1;
      }
    }
  }
}
</style>